import { useForm } from 'react-hook-form'
// @ts-nocheck
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { forgotPassword } from '../api/auth'
import { useEffect, useState } from 'react'
import { FormField } from '@shared/ui/FormField'
import { Input } from '@shared/ui/Input'
import { Button } from '@shared/ui/Button'
import { useToast } from '@shared/toast/ToastProvider'
import { http } from '@shared/libs/http'

const schema = z.object({ email: z.string().email() })
type FormValues = z.infer<typeof schema>

export function ForgotPasswordPage() {
  const [msg, setMsg] = useState<string | null>(null)
  const [err, setErr] = useState<string | null>(null)
  const { register, handleSubmit, formState } = useForm<FormValues>({ resolver: zodResolver(schema) })
  const { push } = useToast()

  // Prime CSRF cookie for POSTs
  useEffect(() => {
    http.get('/auth/session').catch(() => {})
  }, [])

  const onSubmit = async (v: FormValues) => {
    setErr(null)
    try {
      await forgotPassword(v)
      setMsg('If the email exists, a code has been sent')
    } catch (e: any) {
      const m = e?.response?.data?.detail ?? 'Request failed'
      setErr(m)
      push({ type: 'error', title: 'Request failed', description: m })
    }
  }

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="w-full max-w-sm bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-semibold mb-4">Forgot password</h1>
        {msg && <div className="mb-2 text-sm text-success">{msg}</div>}
        {err && <div className="mb-2 text-sm text-danger">{err}</div>}
        <form className="grid gap-3" onSubmit={handleSubmit(onSubmit)}>
          <FormField label="Email" message={formState.errors.email?.message}>
            <Input type="email" {...register('email')} />
          </FormField>
          <Button disabled={formState.isSubmitting}>Send code</Button>
        </form>
      </div>
    </div>
  )
}
 
// @ts-nocheck
